import { render, staticRenderFns } from "./vs-drop.vue?vue&type=template&id=074e1c84&scoped=true"
import script from "./vs-drop.vue?vue&type=script&lang=js"
export * from "./vs-drop.vue?vue&type=script&lang=js"
import style0 from "./vs-drop.vue?vue&type=style&index=0&id=074e1c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e1c84",
  null
  
)

export default component.exports